module.exports = __webpack_public_path__ + "img/CareLogo.e3338534.svg";